module.exports = __webpack_public_path__ + "img/mall_01.dbdaadc6.png";